export default "__VITE_ASSET__d1be4afc__"